var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "font-size": "13px", "line-height": "18px" } },
    [
      _c(
        "div",
        { staticStyle: { "text-align": "right" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.generateAndDownloadPDFs()
                },
              },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("mdfeTranslate.DownloadAllInvoiceInformation"))
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "virtualContainer",
          staticClass: "virtual-scroll-container",
          on: { scroll: _vm.handleScroll },
        },
        [
          _c(
            "div",
            {
              staticClass: "virtual-scroll-placeholder",
              style: { height: _vm.totalHeight + "px" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "virtual-scroll-content",
                  style: { transform: "translateY(" + _vm.offsetY + "px)" },
                },
                _vm._l(_vm.visibleItems, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: { color: "#000", padding: "7px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { padding: "7px" },
                          attrs: { id: "pdfData" + index },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                "font-weight": "bold",
                                "margin-bottom": "15px",
                              },
                            },
                            [
                              _vm._v(
                                "DECLARO QUE RECEBI OS VOLUMES DESTE CONHECIMENTO EM PERFEITO ESTADO PELO QUE DOU POR CUMPRIDO O PRESENTE CONTRATO DE TRANSPORTE"
                              ),
                            ]
                          ),
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _vm._m(0, true),
                            _vm._m(1, true),
                            _c(
                              "div",
                              { staticStyle: { flex: "1", display: "flex" } },
                              [
                                _vm._m(2, true),
                                _c("div", { staticStyle: { width: "200px" } }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "text-align": "right",
                                        "font-size": "22px",
                                      },
                                    },
                                    [_vm._v("CT-E")]
                                  ),
                                  _c("div", [
                                    _vm._v(
                                      "Nº DOCUMENTO：" +
                                        _vm._s(item.invoiceNumber)
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v("SÉRIE：" + _vm._s(item.serie)),
                                  ]),
                                ]),
                              ]
                            ),
                          ]),
                          _c("div", {
                            staticStyle: {
                              padding: "7px 0",
                              "border-top": "2px dashed black",
                            },
                          }),
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "200px",
                                  display: "flex",
                                  "flex-direction": "column",
                                  "justify-content": "end",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("TIPO DO CT-e")]
                                ),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.documentType[item.tpCTe])),
                                ]),
                              ]
                            ),
                            _c("div", { staticStyle: { width: "300px" } }, [
                              _c(
                                "div",
                                { staticStyle: { "font-weight": "bold" } },
                                [
                                  _vm._v(
                                    _vm._s(item.company.companyName) +
                                      " " +
                                      _vm._s(item.company.fantasyName)
                                  ),
                                ]
                              ),
                              _c("div", [
                                _vm._v(
                                  _vm._s(item.company.address) +
                                    ", " +
                                    _vm._s(item.company.number)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(_vm._s(item.company.neighborhood)),
                              ]),
                              _c("div", [
                                _vm._v(
                                  "Telefone: " + _vm._s(item.company.telephone)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  _vm._s(item.company.city) +
                                    " - " +
                                    _vm._s(item.company.state) +
                                    " "
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "20px" } },
                                  [
                                    _vm._v(
                                      "CEP: " + _vm._s(item.company.zipcode)
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("CNPJ:")]
                                ),
                                _vm._v(" " + _vm._s(item.company.companyCnpj)),
                              ]),
                              _c("div", [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("IE:")]
                                ),
                                _vm._v(" " + _vm._s(item.company.ie)),
                              ]),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v("TIPO DO SERVIÇO")]
                                ),
                                _c("div", [
                                  _vm._v(_vm._s(_vm.serviceType[item.tpServ])),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticStyle: { flex: "1" } }, [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _vm._m(3, true),
                                _c(
                                  "div",
                                  {
                                    staticStyle: { flex: "1", display: "flex" },
                                  },
                                  [
                                    _c("div", { staticStyle: { flex: "1" } }, [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                          },
                                        },
                                        [_vm._v("MODAL")]
                                      ),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(_vm.transportMode[item.modal])
                                        ),
                                      ]),
                                    ]),
                                    _vm._m(4, true),
                                  ]
                                ),
                              ]),
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c("div", { staticStyle: { width: "80px" } }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-weight": "bold",
                                        "text-align": "right",
                                      },
                                    },
                                    [_vm._v("MODEL")]
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [_vm._v(_vm._s(item.modelo))]
                                  ),
                                ]),
                                _c("div", { staticStyle: { width: "80px" } }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-weight": "bold",
                                        "text-align": "right",
                                      },
                                    },
                                    [_vm._v("SÉRIE")]
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [_vm._v(_vm._s(item.serie))]
                                  ),
                                ]),
                                _c("div", { staticStyle: { width: "120px" } }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-weight": "bold",
                                        "text-align": "right",
                                      },
                                    },
                                    [_vm._v("NÚMERO")]
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [_vm._v(_vm._s(item.invoiceNumber))]
                                  ),
                                ]),
                                _c("div", { staticStyle: { flex: "1" } }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-weight": "bold",
                                        "text-align": "center",
                                      },
                                    },
                                    [_vm._v("DATA E HORA DE EMISSÃO")]
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [_vm._v(_vm._s(item.cteCreateDate))]
                                  ),
                                ]),
                              ]),
                              _c("img", {
                                attrs: { id: "barcodeCon" + index },
                              }),
                              _c("div", [
                                _c("div", [_vm._v("Chave de Acesso")]),
                                _c("div", [
                                  _vm._v(" " + _vm._s(item.invoiceKey) + " "),
                                ]),
                              ]),
                            ]),
                            _c("div", { staticStyle: { width: "200px" } }, [
                              _c("div", {
                                staticStyle: { "margin-top": "15px" },
                                attrs: { id: "qrcode" + index },
                              }),
                            ]),
                          ]),
                          _vm._m(5, true),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                color: "#000",
                                "margin-bottom": "5px",
                              },
                            },
                            [
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _c(
                                  "div",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [
                                    _vm._v(
                                      " CÓDIGO FISCAL DE OPERAÇÕES E PRESTAÇÕES - NATUREZA DA OPERAÇÃO "
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _vm._v(" " + _vm._s(item.cfop) + " "),
                                ]),
                              ]),
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _c(
                                  "div",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v(" Protocolo de Autorização de Uso ")]
                                ),
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.protocolo) +
                                      " - " +
                                      _vm._s(item.cteCreateDate) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "margin-bottom": "5px",
                              },
                            },
                            [
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _c(
                                  "div",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v(" INÍCIO DA PRESTAÇÃO ")]
                                ),
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.startCity) +
                                      " - " +
                                      _vm._s(item.startUf) +
                                      " "
                                  ),
                                ]),
                              ]),
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _c(
                                  "div",
                                  { staticStyle: { "font-weight": "bold" } },
                                  [_vm._v(" TÉRMINO DA PRESTAÇÃO ")]
                                ),
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.endCity) +
                                      " - " +
                                      _vm._s(item.endUf) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "margin-bottom": "10px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    flex: "1",
                                    border: "1px solid #000",
                                    padding: "7px",
                                    "margin-right": "5px",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v("REMETENTE "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-left": "15px" },
                                      },
                                      [_vm._v(_vm._s(item.remetente.name))]
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v("ENDEREÇO "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-left": "15px" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(item.remetente.address) +
                                            _vm._s(
                                              item.remetente.city
                                                ? ", " + item.remetente.city
                                                : ""
                                            ) +
                                            " " +
                                            _vm._s(item.remetente.number) +
                                            " " +
                                            _vm._s(item.remetente.neighborhood)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { flex: "1" } },
                                        [
                                          _c("div", [
                                            _vm._v("MUNICÍPIO "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.remetente.city) +
                                                    _vm._s(
                                                      item.remetente.state
                                                        ? " - " +
                                                            item.remetente.state
                                                        : ""
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("CNPJ / CPF "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.remetente.cnpj)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("PAÍS "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.remetente.country || ""
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticStyle: { flex: "1" } },
                                        [
                                          _c("div", [
                                            _vm._v("CEP "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.remetente.zipcode)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("INSCRIÇÃO "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.remetente.ie)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("FONE "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.remetente.telephone
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    flex: "1",
                                    border: "1px solid #000",
                                    padding: "7px",
                                    "margin-left": "5px",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v("DESTINATÁRIO "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-left": "15px" },
                                      },
                                      [_vm._v(_vm._s(item.destinatario.name))]
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v("ENDEREÇO "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-left": "15px" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(item.destinatario.address) +
                                            _vm._s(
                                              item.destinatario.city
                                                ? ", " + item.remetente.city
                                                : ""
                                            ) +
                                            " " +
                                            _vm._s(item.destinatario.number) +
                                            " " +
                                            _vm._s(
                                              item.destinatario.neighborhood
                                            )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { flex: "1" } },
                                        [
                                          _c("div", [
                                            _vm._v("MUNICÍPIO "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.destinatario.city
                                                  ) +
                                                    _vm._s(
                                                      item.destinatario.state
                                                        ? " - " +
                                                            item.destinatario
                                                              .state
                                                        : ""
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("CNPJ / CPF "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.destinatario.cnpj)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("PAÍS "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.destinatario.country ||
                                                      ""
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticStyle: { flex: "1" } },
                                        [
                                          _c("div", [
                                            _vm._v("CEP "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.destinatario.zipcode
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("INSCRIÇÃO "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.destinatario.ie)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("FONE "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.destinatario.telephone
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "margin-bottom": "10px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    flex: "1",
                                    border: "1px solid #000",
                                    padding: "7px",
                                    "margin-right": "5px",
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v("EXPEDIDOR "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-left": "15px" },
                                      },
                                      [_vm._v(_vm._s(item.expedidor.name))]
                                    ),
                                  ]),
                                  _c("div", [
                                    _vm._v("ENDEREÇO "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-left": "15px" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(item.expedidor.address) +
                                            _vm._s(
                                              item.expedidor.city
                                                ? ", " + item.expedidor.city
                                                : ""
                                            ) +
                                            " " +
                                            _vm._s(item.expedidor.number) +
                                            " " +
                                            _vm._s(item.expedidor.neighborhood)
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { flex: "1" } },
                                        [
                                          _c("div", [
                                            _vm._v("MUNICÍPIO "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.expedidor.city) +
                                                    _vm._s(
                                                      item.expedidor.state
                                                        ? " - " +
                                                            item.expedidor.state
                                                        : ""
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("CNPJ / CPF "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.expedidor.cnpj)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("PAÍS "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.expedidor.country || ""
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticStyle: { flex: "1" } },
                                        [
                                          _c("div", [
                                            _vm._v("CEP "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.expedidor.zipcode)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("INSCRIÇÃO "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.expedidor.ie)
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v("FONE "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "margin-left": "15px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.expedidor.telephone
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    flex: "1",
                                    border: "1px solid #000",
                                    padding: "7px",
                                    "margin-left": "5px",
                                  },
                                },
                                [
                                  item.customerId === 24005 ||
                                  item.customerId === 24147
                                    ? _c("div", [
                                        _c("div", [
                                          _vm._v("RECEBEDOR "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "15px",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.toma.name))]
                                          ),
                                        ]),
                                        _c("div", [
                                          _vm._v("ENDEREÇO "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "15px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.toma.address) +
                                                  _vm._s(
                                                    item.toma.city
                                                      ? ", " + item.toma.city
                                                      : ""
                                                  ) +
                                                  " " +
                                                  _vm._s(item.toma.number) +
                                                  " " +
                                                  _vm._s(item.toma.neighborhood)
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          { staticStyle: { display: "flex" } },
                                          [
                                            _c(
                                              "div",
                                              { staticStyle: { flex: "1" } },
                                              [
                                                _c("div", [
                                                  _vm._v("MUNICÍPIO "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.toma.city) +
                                                          _vm._s(
                                                            item.toma.state
                                                              ? " - " +
                                                                  item.toma
                                                                    .state
                                                              : ""
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v("CNPJ / CPF "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.toma.cnpj)
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v("PAÍS "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.toma.country
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticStyle: { flex: "1" } },
                                              [
                                                _c("div", [
                                                  _vm._v("CEP "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.toma.zipcode
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v("INSCRIÇÃO "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.toma.ie)
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v("FONE "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.toma.telephone
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _c("div", [
                                        _c("div", [
                                          _vm._v("RECEBEDOR "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "15px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.recebedor.name)
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c("div", [
                                          _vm._v("ENDEREÇO "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "15px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.recebedor.address) +
                                                  _vm._s(
                                                    item.recebedor.city
                                                      ? ", " +
                                                          item.recebedor.city
                                                      : ""
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    item.recebedor.number
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    item.recebedor.neighborhood
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c(
                                          "div",
                                          { staticStyle: { display: "flex" } },
                                          [
                                            _c(
                                              "div",
                                              { staticStyle: { flex: "1" } },
                                              [
                                                _c("div", [
                                                  _vm._v("MUNICÍPIO "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.recebedor.city
                                                        ) +
                                                          _vm._s(
                                                            item.recebedor.state
                                                              ? " - " +
                                                                  item.recebedor
                                                                    .state
                                                              : ""
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v("CNPJ / CPF "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.recebedor.cnpj
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v("PAÍS "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.recebedor.country
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticStyle: { flex: "1" } },
                                              [
                                                _c("div", [
                                                  _vm._v("CEP "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.recebedor.zipcode
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v("INSCRIÇÃO "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.recebedor.ie
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v("FONE "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "15px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.recebedor
                                                            .telephone
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                border: "1px solid #000",
                                padding: "7px",
                                "margin-bottom": "10px",
                              },
                            },
                            [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c("div", { staticStyle: { flex: "1" } }, [
                                  _vm._v(
                                    " TOMADOR DO SERVIÇO " +
                                      _vm._s(item.toma.name) +
                                      " "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      flex: "1",
                                      "padding-left": "10px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " MUNICÍPIO " +
                                        _vm._s(item.toma.city) +
                                        _vm._s(
                                          item.toma.state
                                            ? " - " + item.toma.state
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c("div", { staticStyle: { flex: "1" } }, [
                                  _vm._v(" CEP "),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "15px" } },
                                    [_vm._v(_vm._s(item.toma.zipcode))]
                                  ),
                                ]),
                              ]),
                              _c("div", [
                                _vm._v(" ENDEREÇO "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-left": "10px",
                                      "margin-right": "20px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.toma.address) +
                                        _vm._s(
                                          item.toma.city
                                            ? ", " + item.toma.city
                                            : ""
                                        ) +
                                        " " +
                                        _vm._s(item.toma.number) +
                                        " " +
                                        _vm._s(item.toma.neighborhood)
                                    ),
                                  ]
                                ),
                                _vm._v(" PAÍS"),
                                _c(
                                  "span",
                                  { staticStyle: { "padding-left": "10px" } },
                                  [_vm._v(_vm._s(item.toma.country || ""))]
                                ),
                              ]),
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c("div", { staticStyle: { flex: "1" } }, [
                                  _vm._v(" CNPJ / CPF "),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "15px" } },
                                    [_vm._v(_vm._s(item.toma.cnpj))]
                                  ),
                                ]),
                                _c("div", { staticStyle: { flex: "1" } }, [
                                  _vm._v(" INSCRIÇÃO "),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "15px" } },
                                    [_vm._v(_vm._s(item.toma.ie))]
                                  ),
                                ]),
                                _c("div", { staticStyle: { flex: "1" } }, [
                                  _vm._v(" FONE "),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "15px" } },
                                    [_vm._v(_vm._s(item.toma.telephone))]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  border: "1px solid #000",
                                  padding: "7px",
                                },
                              },
                              [
                                _c("div", [_vm._v("PRODUTO PREDOMINANTE")]),
                                _c("div", [
                                  _vm._v(_vm._s(item.product || null)),
                                ]),
                              ]
                            ),
                            _vm._m(6, true),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  border: "1px solid #000",
                                  padding: "7px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [_vm._v("VALOR TOTAL DA CARGA")]
                                ),
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _vm._v(
                                      "R$ " +
                                        _vm._s(
                                          _vm.formatNumber(item.productAmount)
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                border: "1px solid #000",
                                padding: "7px",
                              },
                            },
                            [
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _vm._v("QUANTIDADE：1"),
                              ]),
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _vm._v("PESO BRUTO (KG)：" + _vm._s(item.peso)),
                              ]),
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _vm._v("QUANTIDADE DE PACOTES：01"),
                              ]),
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _vm._v(
                                  "PESO AFERIDO (KG)：" +
                                    _vm._s(item.pesoAferido)
                                ),
                              ]),
                              _c("div", { staticStyle: { flex: "1" } }, [
                                _vm._v("CUBAGEM(M3)：" + _vm._s(item.volumes)),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                border: "1px solid #000",
                                padding: "7px 7px 0 7px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    padding: "7px",
                                    "text-align": "center",
                                    border: "1px solid #000",
                                  },
                                },
                                [
                                  _vm._v(
                                    "COMPONENTES DO VALOR DA PRESTAÇÃO DE SERVIÇO"
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _vm._l(
                                    item.prest.freteDetail,
                                    function (list, ind) {
                                      return _c(
                                        "div",
                                        {
                                          key: ind,
                                          staticStyle: {
                                            flex: "1",
                                            "border-right": "1px solid #000",
                                            "padding-right": "10px",
                                          },
                                        },
                                        [
                                          _vm._m(7, true),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticStyle: { flex: "1" } },
                                                [_vm._v(_vm._s(list.name))]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    flex: "1",
                                                    "text-align": "right",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatNumber(
                                                        list.value
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "1",
                                        "text-align": "right",
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _vm._v("VALOR TOTAL DO SERVIÇO"),
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "R$ " +
                                            _vm._s(
                                              _vm.formatNumber(item.prest.frete)
                                            )
                                        ),
                                      ]),
                                      _c("div", [
                                        _vm._v("VALOR TOTAL A RECEBER"),
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          "R$ " +
                                            _vm._s(
                                              _vm.formatNumber(
                                                item.prest.receivablesFee
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                border: "1px solid #000",
                                padding: "7px 7px 0 7px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    padding: "7px",
                                    "text-align": "center",
                                    border: "1px solid #000",
                                  },
                                },
                                [_vm._v("INFORMAÇÕES RELATIVAS A IMPOSTO")]
                              ),
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "400px",
                                      "border-right": "1px solid #000",
                                      "padding-right": "10px",
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        "CLASSIFICAÇÃO TRIBUTÁRIA DO SERVIÇO"
                                      ),
                                    ]),
                                    _c("div", [_vm._v(_vm._s(item.icms.cst))]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      flex: "1",
                                      "border-right": "1px solid #000",
                                      padding: "0 10px",
                                    },
                                  },
                                  [
                                    _c("div", [_vm._v("BASE DE CÁLCULO")]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "right" },
                                      },
                                      [
                                        _vm._v(
                                          "R$ " +
                                            _vm._s(
                                              _vm.formatNumber(item.icms.vbc)
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      flex: "1",
                                      "border-right": "1px solid #000",
                                      padding: "0 10px",
                                    },
                                  },
                                  [
                                    _c("div", [_vm._v("ALÍQUOTA DO ICMS")]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "right" },
                                      },
                                      [_vm._v(_vm._s(item.icms.picms) + " %")]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      flex: "1",
                                      "border-right": "1px solid #000",
                                      padding: "0 10px",
                                    },
                                  },
                                  [
                                    _c("div", [_vm._v("VALOR DO ICMS")]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "right" },
                                      },
                                      [
                                        _vm._v(
                                          "R$ " +
                                            _vm._s(
                                              _vm.formatNumber(item.icms.vicms)
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      flex: "1",
                                      "border-right": "1px solid #000",
                                      padding: "0 10px",
                                    },
                                  },
                                  [
                                    _c("div", [_vm._v("% RED BC.")]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "text-align": "right" },
                                      },
                                      [_vm._v("% " + _vm._s(item.icms.predbc))]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                border: "1px solid #000",
                                padding: "7px 7px 0 7px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    padding: "7px",
                                    "text-align": "center",
                                    border: "1px solid #000",
                                  },
                                },
                                [
                                  _vm._v(
                                    "DOCUMENTOS ORIGINÁRIOS(NOTA FISCAL ELETRÔNICA)"
                                  ),
                                ]
                              ),
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      flex: "1",
                                      display: "flex",
                                      "border-right": "1px solid #000",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { width: "100px" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v("MODELO")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.associationCte.modelo)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { width: "100px" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v("SERIE")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.associationCte.serie)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { width: "100px" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v("NÚMERO")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.associationCte.number)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("div", { staticStyle: { flex: "1" } }, [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [_vm._v("CHAVE DE ACESSO")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(item.associationCte.key)
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      flex: "1",
                                      display: "flex",
                                      "border-right": "1px solid #000",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          width: "100px",
                                          "padding-left": "10px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v("MODELO")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.nfeOriginalFile.modelo
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { width: "100px" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v("SERIE")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.nfeOriginalFile.serie)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticStyle: { width: "100px" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v("NÚMERO")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "left",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.nfeOriginalFile.number
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("div", { staticStyle: { flex: "1" } }, [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [_vm._v("CHAVE DE ACESSO")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(item.nfeOriginalFile.key)
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  border: "1px solid #000",
                                  padding: "7px",
                                },
                              },
                              [
                                _c("div", [_vm._v("INFORMAÇÕES ADICIONAIS")]),
                                _c(
                                  "div",
                                  _vm._l(
                                    item.additionalInfo,
                                    function (list, ind) {
                                      return _c("div", { key: ind }, [
                                        _vm._v(_vm._s(list)),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  flex: "1",
                                  border: "1px solid #000",
                                  padding: "7px 7px 0 7px",
                                },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        border: "1px solid #000",
                                        padding: "7px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "INFORMAÇÕES ESPECÍFICAS DO MODAL RODOVIÁRIO"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "1",
                                            "border-right": "1px solid #000",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _vm._v("RNTRC DA EMPRESA"),
                                          ]),
                                          _c("div", [
                                            _vm._v(_vm._s(item.company.rntrc)),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "2",
                                            "padding-left": "10px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " ESTE CONHECIMENTO DE TRANSPORTE ATENDE À LEGISLAÇÃO DE TRANSPORTE RODOVIÁRIO EM VIGOR "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._m(8, true),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "35%" } }, [
      _c("div", [_vm._v("NOME")]),
      _c("div", {
        staticStyle: {
          "border-bottom": "1px solid black",
          width: "100%",
          "margin-top": "15px",
        },
      }),
      _c("div", [_vm._v("DOCUMENTO")]),
      _c("div", {
        staticStyle: {
          "border-bottom": "1px solid black",
          width: "100%",
          "margin-top": "15px",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "200px", padding: "0 10px" } }, [
      _c("div", {
        staticStyle: {
          width: "100%",
          height: "80px",
          border: "1px solid black",
        },
      }),
      _c("div", { staticStyle: { "text-align": "center" } }, [
        _vm._v("ASSINATURA/CARIMBO"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { flex: "1" } }, [
      _c("div", [_vm._v("TÉRMINO DA PRESTAÇÃO - DATA/HORA")]),
      _c("div", { staticStyle: { display: "flex", "padding-right": "10px" } }, [
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
        _vm._v("/ "),
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
        _vm._v("/ "),
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
        _vm._v(": "),
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
      ]),
      _c("div", [_vm._v("INÍCIO DA PRESTAÇÃO - DATA/HORA")]),
      _c("div", { staticStyle: { display: "flex", "padding-right": "10px" } }, [
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
        _vm._v("/ "),
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
        _vm._v("/ "),
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
        _vm._v(": "),
        _c("div", {
          staticStyle: { flex: "1", "border-bottom": "1px solid black" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          flex: "1",
          "text-align": "center",
          "font-weight": "bold",
        },
      },
      [
        _c("div", [_vm._v("DACTE")]),
        _c("div", [_vm._v("Documento Auxiliar do")]),
        _c("div", [_vm._v("Conhecimento de Transporte")]),
        _c("div", [_vm._v("Eletrônico")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          flex: "1",
          "text-align": "right",
          "padding-right": "10px",
        },
      },
      [_c("div", [_vm._v("FL")]), _c("div", [_vm._v("1/1")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", color: "#000", margin: "10px 0" } },
      [
        _c("div", { staticStyle: { width: "200px" } }, [
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("INDICADOR DO CT-E"),
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", { staticStyle: { flex: "1" } }, [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "inline-block",
                    padding: "0 5px",
                    border: "2px solid #000",
                    "margin-right": "10px",
                    width: "25px",
                    height: "25px",
                  },
                },
                [_vm._v("X")]
              ),
              _vm._v("SIM "),
            ]),
            _c("div", { staticStyle: { flex: "1" } }, [
              _c("div", {
                staticStyle: {
                  display: "inline-block",
                  padding: "0 5px",
                  border: "2px solid #000",
                  "margin-right": "10px",
                  width: "25px",
                  height: "25px",
                },
              }),
              _vm._v("NÃO "),
            ]),
          ]),
        ]),
        _c("div", { staticStyle: { width: "260px" } }, [
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("INF. DO CT-E GLOBALIZADO"),
          ]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", { staticStyle: { flex: "1" } }, [
              _c("span", {
                staticStyle: {
                  display: "inline-block",
                  padding: "0 5px",
                  border: "2px solid #000",
                  "margin-right": "10px",
                  width: "25px",
                  height: "25px",
                },
              }),
              _vm._v("SIM "),
            ]),
            _c("div", { staticStyle: { flex: "1" } }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "inline-block",
                    padding: "0 5px",
                    border: "2px solid #000",
                    "margin-right": "10px",
                    width: "25px",
                    height: "25px",
                  },
                },
                [_vm._v("X")]
              ),
              _vm._v("NÃO "),
            ]),
          ]),
        ]),
        _c("div", { staticStyle: { flex: "1" } }, [
          _vm._v(" Consulta "),
          _c("span", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("http://www.cte.fazenda.gov.br"),
          ]),
        ]),
        _c("div", { staticStyle: { flex: "1" } }, [
          _c("div", [_vm._v("TIPO DE CONTRATAÇÃO")]),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", { staticStyle: { flex: "1" } }, [
              _c("span", {
                staticStyle: {
                  display: "inline-block",
                  padding: "0 5px",
                  border: "2px solid #000",
                  "margin-right": "10px",
                  width: "25px",
                  height: "25px",
                },
              }),
              _vm._v("REDESPACHO "),
            ]),
            _c("div", { staticStyle: { flex: "1" } }, [
              _c("div", {
                staticStyle: {
                  display: "inline-block",
                  padding: "0 5px",
                  border: "2px solid #000",
                  "margin-right": "10px",
                  width: "25px",
                  height: "25px",
                },
              }),
              _vm._v("SUBCONTRATAÇÃO "),
            ]),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { flex: "1", border: "1px solid #000", padding: "7px" } },
      [
        _c("div", [_vm._v("OUTRAS CARACTERÍSTICAS DA CARGA")]),
        _c("div", [_vm._v("null")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { display: "flex" } }, [
      _c("div", { staticStyle: { flex: "1" } }, [_vm._v("NOME")]),
      _c("div", { staticStyle: { flex: "1", "text-align": "right" } }, [
        _vm._v("VALOR"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "margin-bottom": "10px" } },
      [
        _c(
          "div",
          {
            staticStyle: {
              flex: "1",
              border: "1px solid #000",
              padding: "7px",
            },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  border: "1px solid #000",
                  padding: "7px",
                  "margin-bottom": "100px",
                },
              },
              [_vm._v(" USO EXCLUSIVO DO EMISSOR DO CT - E ")]
            ),
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              flex: "1",
              border: "1px solid #000",
              padding: "7px",
            },
          },
          [
            _c(
              "div",
              { staticStyle: { border: "1px solid #000", padding: "7px" } },
              [_vm._v("RESERVADO AO FISCO")]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }